<template>
  <div id="scores" class="nissan-quiz-screen">
    <div class="scores-title" :class="{ 'mt-0': isTIER3SpecialEvent }">Your score:</div>
    <div class="scores-score">{{finalScore}}</div>

    <v-container v-if="isTIER3SpecialEvent">
      <div class="winTagline01">THANK YOU<br>FOR PLAYING</div>
    </v-container>
    <v-container v-else>
      <div class="winTagline01">SEE A BRAND AMBASSADOR</div>
      <div class="winTagline02">TO CLAIM YOUR PRIZE!</div>
      <input
        v-model="claimCode"
        type="text"
        maxlength="4"
        class="nissan-quiz-claimbutton"
        id="nissan-quiz-claimbutton"
        name="claimcode"
        placeholder="CLAIM CODE"
        required
      />
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Scores',
  computed: {
    ...mapGetters(['singleUserScore', 'gameRoomId']),
    claimCode: {
      get() {
        return this.$store.state.claimCode;
      },
      set(value) {
        this.$store.commit('setClaimCode', { value });
      },
    },
    isTIER3SpecialEvent: {
      get() {
        return this.$store.state.config.isTIER3SpecialEvent;
      },
    },
  },
  mounted() {
    this.$store.commit('setClaimCode', { value: '' });
    this.finalScore = this.singleUserScore;
    this.$root.$emit('requestExit');
  },
  watch: {
    claimCode(newVal) {
      if (newVal === '3467') {
        this.$store.commit('setTriggerDisconnect', { value: true });

        this.$keen.recordEvent('claimCode', {
          item: 'Winner - Scores',
        });
      }
    },
  },
  data() {
    return {
      finalScore: 0,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./../styles/_global.scss";
@import "./../styles/_variables.scss";

#scores {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}
.mt-0 {
  margin-top: 0 !important;
}

.scores-title {
  font-size: 25px;
  text-align: center;
  width: 100%;
  margin-top: 60px;
  font-family: "Nissan-Brand-Bold";
}
.scores-score {
  text-align: center;
  width: 100%;
  font-family: "Nissan-Brand-Bold";
  font-size: 65px;
}

.winTagline01 {
  margin-top: 20px;
  text-align: center;
  width: 100%;
  font-family: 'Nissan-Brand-Bold';
  font-size: 30px;
  padding: 0 20px;
}

.winTagline02 {
  text-align: center;
  width: 100%;
  font-family: 'Nissan-Brand-Light';
  font-size: 30px;
  padding: 0 20px;
}

@media only screen and (max-width: 320px) {
  .scores-title {
    font-size: 20px;
    line-height: 60px;
    margin-top: 0px;
  }

  .scores-score {
    font-size: 80px;
  }

  .winTagline01 {
    margin-top: 10px;
    font-size: 20px;
    padding: 0 10px;
  }

  .winTagline02 {
    font-size: 20px;
    padding: 0 10px;
  }
}

.nissan-quiz-claimbutton {
  left: 0;
  right: 0;
  bottom: 30px;
  width: 60%;
  padding: 15px;
  border-width: 2px;
  border-color: #FFFFFF;
  border-style: solid;
  background-color: #000;
  color: #FFFFFF;
  display: table;
  margin: 20px auto 0px;
  font-size: 25px;
  text-align: center;
  &.active {
    color: #FFFFFF;
  }

  &.selected {
    background-color: #FFFFFF;
    color: #000000;
  }

  &.disabled {
    opacity: 0.5;
  }
}
</style>
